<template>
  <div class="ajaxForm">
    <h2>Log</h2>
    <v-data-table
      :headers="headers"
      :items="logsFile"
      class="elevation-1"
      hide-actions
      v-if="logsFile"
    >
      <template v-slot:items="props">
        <td>{{ props.item.action }}</td>
        <td>{{ props.item.department.name }}</td>
        <td>
          <EntityZ :entity="props.item.user" />
        </td>
        <td>{{ props.item.timestamp | formatDateTime }}</td>
      </template>
    </v-data-table>
    <hr />
    <v-btn @click="$emit('close-logs')">Close</v-btn>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Logs",
  components: {
    EntityZ,
  },
  data() {
    return {
      headers: [
        {
          text: "Action",
          sortable: false,
          value: "action",
        },
        {
          text: "Department",
          sortable: false,
          value: "department.name",
        },
        {
          text: "User",
          sortable: false,
          value: "user",
        },
        {
          text: "Created",
          sortable: false,
          value: "timestamp",
        },
      ],
      logsFile: null,
    };
  },
  methods: {
    async fetchLogsFile() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.id}/logs`
      );
      // console.log(response.data);
      this.logsFile = response.data;
    },
  },
  watch: {
    "$route.params.id": function () {
      this.fetchLogsFile();
    },
  },
  created() {
    this.fetchLogsFile();
  },
};
</script>
